import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import 'antd/dist/antd.min.css';
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Users from "./pages/user/List";
import FaqList from "./pages/faq/List";
import FaqAdd from "./pages/faq/Add";
import PageManagementList from "./pages/page-management/List";
import PageManagementForm from "./pages/page-management/Form";
import SettingForm from "./pages/setting/Form";
import UserProfile from "./pages/AdminProfile";
import PlanList from "./pages/plan/List";
import PlanForm from "./pages/plan/Form";
import ContactUsList from "./pages/contactUs/List";
import ReportList from "./pages/userReport/List";
import BlogList from "./pages/blog/List";
import BlogForm from "./pages/blog/Form";
import BlockList from "./pages/userBlock/List";
import CategoryList from "./pages/category/List";
import CategoryForm from "./pages/category/Form";
import ReviewList from "./pages/review/List";
import ReviewForm from "./pages/review/Form";
import IdeaList from "./pages/idea/List";
import QuestionList from "./pages/question/List";
import IdeaPurchaseList from "./pages/idea-purchase/List";
import NewsLetterList from "./pages/newsLetter/List";
import ReportElementList from "./pages/reportElement/List";
import ReportElementAdd from "./pages/reportElement/Add";
import TransactionHistoryList from "./pages/transaction-history/List";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<SignIn />} />
        <Route path="/" element={<Main><Home /></Main>} />
        <Route path="/dashboard" element={<Main><Home /></Main>} />
        <Route path="/users" element={<Main><Users /></Main>} />

        <Route path="/faq" element={<Main><FaqList /></Main>} />
        <Route path="/faq/add" element={<Main><FaqAdd /></Main>} />
        <Route path="/faq/update/:faqId" element={<Main><FaqAdd /></Main>} />

        <Route path="/report-element" element={<Main><ReportElementList /></Main>} />
        <Route path="/report-element/add" element={<Main><ReportElementAdd /></Main>} />
        <Route path="/report-element/update/:faqId" element={<Main><ReportElementAdd /></Main>} />

        <Route path="/page-management" element={<Main><PageManagementList /></Main>} />
        <Route path="/page-management/add" element={<Main><PageManagementForm /></Main>} />
        <Route path="/page-management/update/:settingId" element={<Main><PageManagementForm /></Main>} />

        <Route path="/settings" element={<Main><SettingForm /></Main>} />

        <Route path="/ideas" element={<Main><IdeaList /></Main>} />
        <Route path="/idea-purchase" element={<Main><IdeaPurchaseList /></Main>} />

        <Route path="/questions" element={<Main><QuestionList /></Main>} />

        <Route path="/transaction-history" element={<Main><TransactionHistoryList /></Main>} />

        <Route path="/blog-management" element={<Main><BlogList /></Main>} />
        <Route path="/blog-management/add" element={<Main><BlogForm /></Main>} />
        <Route path="/blog-management/update/:blogId" element={<Main><BlogForm /></Main>} />

        <Route path="/category" element={<Main><CategoryList /></Main>} />
        <Route path="/category/add" element={<Main><CategoryForm /></Main>} />
        <Route path="/category/update/:blogId" element={<Main><CategoryForm /></Main>} />

        <Route path="/review" element={<Main><ReviewList /></Main>} />
        <Route path="/review/add" element={<Main><ReviewForm /></Main>} />
        <Route path="/review/update/:blogId" element={<Main><ReviewForm /></Main>} />

        <Route path="/plan" element={<Main><PlanList /></Main>} />
        <Route path="/plan/add" element={<Main><PlanForm /></Main>} />
        <Route path="/plan/update/:planId" element={<Main><PlanForm /></Main>} />

        <Route path="/contact-us" element={<Main><ContactUsList /></Main>} />
        <Route path="/reports" element={<Main><ReportList /></Main>} />
        <Route path="/blocks" element={<Main><BlockList /></Main>} />
        <Route path="/newsletter" element={<Main><NewsLetterList /></Main>} />

        <Route path="/profile" element={<Main><UserProfile /></Main>} />
        <Route path="/users/:userId" element={<Main><Profile /></Main>} />
      </Routes>
    </div>
  );
}

export default App;
